import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@chain-zen/ui'
import { usePathname, useRouter } from 'next/navigation'
import React from 'react'

import type { IRedirectParams } from './enable-app-modal-utils'
import { getModalContent } from './enable-app-modal-utils'

interface EnableAppCompletionModalProps {
  isOpen: boolean
  onClose: () => void
  redirectParams: IRedirectParams
}

/**
 * Modal that is shown on OAuth callbacks after a user is redirected. It gives the status of the enabling of the app.
 */
const EnableAppCompletionModal = (props: EnableAppCompletionModalProps) => {
  const { isOpen, onClose, redirectParams } = props
  const pathname = usePathname()
  const router = useRouter()

  // We want to clear the params after a user is redirected back to the page
  const clearUrlSearchParams = () => {
    router.replace(pathname)
  }

  const modalOnClose = () => {
    clearUrlSearchParams()
    onClose()
  }

  const { title, subtitle, body } = getModalContent(redirectParams)

  return (
    <Dialog open={isOpen} onOpenChange={modalOnClose}>
      <DialogContent className="max-w-lg w-full max-h-[70vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold leading-none tracking-tight">{title}</DialogTitle>
          {!!subtitle && <DialogDescription className="text-sm text-muted-foreground">{subtitle}</DialogDescription>}
        </DialogHeader>
        <div className="py-4">
          <p className="text-sm text-muted-foreground">{body}</p>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export { EnableAppCompletionModal }
